import React from 'react';
import NavBarSub from '../layout/NavBarSub';
import SubWorks from '../layout/SubWorks';
import WorksContent from '../layout/WorksContent';
import OurPeople from '../layout/OurPeople';

const Works = () => {
  return (
    <>
      <NavBarSub />
      <SubWorks />
      <WorksContent />
      <OurPeople />
    </>
  );
};

export default Works;
